import * as authApi from "../../api/auth";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { Auth } from "../../models/Auth";

export const login = createAsyncThunk("auth/login", (data: Auth) => authApi.login(data));

export const logout = createAsyncThunk("auth/logout", () => authApi.logout());

export const getCurrentUser = createAsyncThunk("auth/getCurrentUser", () => authApi.getCurrentUser());
